module.exports = __webpack_public_path__ + "static/media/BoldBlue.36db3941.svg";